import { Breadcrumbs } from '@mui/material';
import LiqExhibitTitleContainer from 'features/shared/UI/layout/LiqExhibitTitleContainer';
import LiqPageContainer from 'features/shared/UI/layout/LiqPageContainer';
import React from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { releases } from './PressReleaseList';
import { TempPage } from 'pages/misc/TempPage';
import liq_badge from '../../../assets/vectors/LIQ_badge.png';

const PressRelease = () => {
    const { date, idx } = useParams<{ date?: string; idx?: string }>();
    const release = releases.find((r) => r.date === date && r.idx === Number(idx));

    if (release) {
        return (
            <LiqPageContainer>
                <div className="col-start-2 lg:col-start-3 col-end-12 lg:col-end-11 flex flex-row justify-between">
                    <Breadcrumbs className="col-start-2 lg:col-end-12 col-end-12" separator=">">
                        <Link to="/" className="hover:underline">
                            Lobby<b>IQ</b>
                        </Link>
                        <Link to="/press-releases" className="hover:underline">
                            Press Releases
                        </Link>
                        <div>
                            {release.title} ({date})
                        </div>
                    </Breadcrumbs>
                </div>
                <div className="lg:mt-8 mt-6 col-start-2 lg:col-start-3 col-end-12 lg:col-end-11">
                    <img src={liq_badge} className="aspect-square lg:w-24 w-16 my-6" alt="logo" />
                    <LiqExhibitTitleContainer title={release.title} subtitle="" />
                    <hr className="h-0.5 my-6 bg-slate-100 rounded" />
                    {release.body}
                </div>
            </LiqPageContainer>
        );
    } else {
        return <TempPage text="That article seems to be missing or doesn't exist" />;
    }
};

export default PressRelease;
